import { deleteRequest, getRequest, postRequest, putRequest } from "../../../apiClient";
import { RolesEndpoint } from "../../../apiEndpoints";

//#region----------------- GET-----------------------
export const GetRoles = async (queryString: any) => {
    var _url = RolesEndpoint.ROLES_URL + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetRoleById = async (id: string | number) => {
    var _url = RolesEndpoint.ROLES_BY_ID_URL(id);
    var res = await getRequest(_url);

    return res;
};

export const GetRolesAccessibilityByRoleId = async (id: string | number) => {
    var _url = RolesEndpoint.ROLES_ACCESSIBILITIES_BY_ROLE_ID_URL(id);
    var res = await getRequest(_url);

    return res;
};
//#endregion

//#region----------------- POST-----------------------
export const CreateRoleService = async (param: any) => {
    var res = await postRequest(RolesEndpoint.ROLES_URL, param);

    return res;
};

export const UpsertRoleAccessibilitiesService = async (id: string | number, param: any) => {
    var res = await postRequest(RolesEndpoint.ROLES_ACCESSIBILITIES_BY_ROLE_ID_URL(id), param);

    return res;
};
//#endregion

//#region----------------- PUT-----------------------
export const EditRoleService = async (id: string | number, param: any) => {
    var res = await putRequest(RolesEndpoint.ROLES_BY_ID_URL(id), param);

    return res;
};
//#endregion

//#region----------------- DELETE-----------------------
export const DeleteRoleService = async (id: string | number, param: any) => {
    var _url = RolesEndpoint.ROLES_DELETE_BY_ID_URL(id);
    var res = await postRequest(_url, param);

    return res;
};

//#endregion